export default __webpack_public_path__ + "static/media/1137.29ca3175.png";